/**
 * Lifestyle / routine mood imagery for Moss Matrix customer pages.
 * Mood only — never use as Moss Matrix product photos, founders, or reviews.
 *
 * Drop real JPGs into frontend/public/images/lifestyle/ using the filenames below.
 * Keep filenames the same to avoid code changes.
 */
const P = process.env.PUBLIC_URL || "";

/**
 * @typedef {{
 *   src: string,
 *   alt: string,
 *   credit?: string,
 *   placeholderLabel: string,
 *   width?: number,
 *   height?: number,
 * }} LifestyleImage
 */

/** @type {Record<string, LifestyleImage>} */
export const LIFESTYLE_IMAGES = {
  heroLifestyle: {
    src: `${P}/images/lifestyle/caribbean-coastal-turquoise.jpg`,
    alt: "Turquoise Caribbean coastal waters — fresh-from-the-sea atmosphere",
    credit: "Unsplash",
    placeholderLabel: "Lifestyle photo coming soon",
    width: 1920,
    height: 1280,
  },
  /** @deprecated Prefer routineCoastal — kept for older imports */
  routineGym: {
    src: `${P}/images/lifestyle/tropical-ocean-horizon.jpg`,
    alt: "Tropical ocean horizon — coastal freshness for an everyday fridge-ready habit",
    credit: "Unsplash",
    placeholderLabel: "Routine image coming soon",
    width: 1920,
    height: 1280,
  },
  routineCoastal: {
    src: `${P}/images/lifestyle/tropical-ocean-horizon.jpg`,
    alt: "Tropical ocean horizon — coastal freshness for an everyday fridge-ready habit",
    credit: "Unsplash",
    placeholderLabel: "Routine image coming soon",
    width: 1920,
    height: 1280,
  },
  routineSmoothie: {
    src: `${P}/images/lifestyle/smoothie-oats-dark.jpg`,
    alt: "Bright kitchen smoothie glasses with oats and fruit — everyday blend-ready mood",
    credit: "Unsplash",
    placeholderLabel: "Routine image coming soon",
    width: 1200,
    height: 800,
  },
  routineMorning: {
    src: `${P}/images/lifestyle/morning-spoon-routine.jpg`,
    alt: "Morning spoon and bowl routine on a calm kitchen surface",
    credit: "Unsplash",
    placeholderLabel: "Routine image coming soon",
    width: 1200,
    height: 800,
  },
  routineKitchen: {
    src: `${P}/images/lifestyle/kitchen-fridge-ready.jpg`,
    alt: "Fridge-ready kitchen counter mood with soft warm light",
    credit: "Unsplash",
    placeholderLabel: "Lifestyle photo coming soon",
    width: 1400,
    height: 933,
  },
  routineTraining: {
    src: `${P}/images/lifestyle/gym-people-training.jpg`,
    alt: "People training in a gym — active everyday routines",
    credit: "Unsplash",
    placeholderLabel: "Lifestyle photo coming soon",
    width: 1400,
    height: 933,
  },
  mixInsHero: {
    src: `${P}/images/lifestyle/natural-ingredients-dark.jpg`,
    alt: "Natural spices and powdered ingredients on a dark surface",
    credit: "Unsplash",
    placeholderLabel: "Lifestyle photo coming soon",
    width: 1400,
    height: 933,
  },
  brandStory: {
    src: `${P}/images/lifestyle/kitchen-fridge-ready.jpg`,
    alt: "Warm kitchen lifestyle still for brand and reward pages",
    credit: "Unsplash",
    placeholderLabel: "Lifestyle photo coming soon",
    width: 1400,
    height: 933,
  },
  packingOrders: {
    src: `${P}/images/lifestyle/packing-orders-placeholder.jpg`,
    alt: "Quiet packing and order-prep mood in a small kitchen workspace",
    credit: "Unsplash",
    placeholderLabel: "Packing photo coming soon",
    width: 1400,
    height: 933,
  },
  gelStillLife: {
    src: `${P}/images/lifestyle/serene-sea-moss-gel-still-life.png`,
    alt: "Sea moss gel jar still life — calm kitchen product atmosphere",
    placeholderLabel: "Product still life coming soon",
    width: 1600,
    height: 1067,
  },
  cleanSceneryCoast: {
    src: `${P}/images/lifestyle/clean-scenery-coast.png`,
    alt: "Bright tropical coastline with clear turquoise water — coastal freshness",
    placeholderLabel: "Coastal scenery coming soon",
    width: 1600,
    height: 1067,
  },
};

/**
 * @param {keyof typeof LIFESTYLE_IMAGES} key
 * @returns {LifestyleImage}
 */
export function getLifestyleImage(key) {
  return LIFESTYLE_IMAGES[key] || LIFESTYLE_IMAGES.brandStory;
}
